import * as setup from '@/setup';
import Button from '@/objects/button';
import Title from '@/objects/title';
import runtime from '@/runtime';
import axios from 'axios';
import * as config from '@/config-APP_TARGET';
import * as auth from '@/utils/auth';

export default class AcceptChallenge extends Phaser.Scene {
	constructor() {
		super({key: 'AcceptChallenge'});
		this.challengeToken = null;
		this.challengeInfo = null;
		this.loadingText = null;
		this.errorText = null;
	}

	create(data) {
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;
		const centerY = height / 2;

		// Estrai token dall'URL o dai dati della scena (se passato come parametro)
		const urlParams = new URLSearchParams(window.location.search);
		this.challengeToken = urlParams.get('challenge_token') || (data && data.challenge_token) || null;

		// Flag per accettazione automatica (quando viene da login automatico)
		this.autoAccept = (data && data.autoAccept === true) || false;

		if (!this.challengeToken) {
			this.showError('Token sfida non trovato');
			return;
		}

		// Sfondo del gioco
		this.add
			.image(centerX, centerY, 'background')
			.setOrigin(0.5, 0.5);

		// Header del gioco
		this.createGameHeader(centerX);

		// Testo di caricamento
		this.loadingText = this.add.text(
			centerX,
			centerY,
			'Caricamento sfida...',
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FFFFFF'}
		).setOrigin(0.5);

		// Carica informazioni sfida
		this.loadChallengeInfo();
	}

	createGameHeader(centerX) {
		// Sfondo del logo
		var graphics = this.add.graphics();
		graphics.lineStyle(setup.styles.backgroundLogo.style);
		graphics.fillStyle(setup.styles.backgroundLogo.style.color);
		graphics.fillRect(0, 0, this.sys.game.config.width, setup.styles.backgroundLogo.height);

		// Logo al centro
		this.add
			.image(centerX, setup.styles.backgroundLogo.height / 2, 'logo')
			.setOrigin(0.5, 0.5)
			.setScale(0.5);

		// Sfondo del ditloide
		var graphicsDitl = this.add.graphics();
		graphicsDitl.lineStyle(setup.styles.backgroundDitloide.style);
		graphicsDitl.fillStyle(setup.styles.backgroundDitloide.style.color);
		graphicsDitl.fillRect(
			0,
			setup.styles.backgroundLogo.height,
			this.sys.game.config.width,
			setup.styles.backgroundDitloide.height
		);
		graphicsDitl.setAlpha(0.2);

		// Ditloide "ACCETTA SFIDA"
		var ditloide = 'ACCETTA SFIDA';
		var let_style = setup.styles.colorLetterStyle;
		if (ditloide.length > 25) {
			let_style = setup.styles.colorLetterStyleMin;
		}
		new Title(
			this,
			centerX,
			setup.styles.backgroundLogo.height + setup.margin.ditloideMarginTop,
			ditloide,
			let_style,
		).setOrigin(0.5);
	}

	loadChallengeInfo() {
		axios.get(`${config.apiUrl}/api/invites/by-token`, {
			params: {
				challenge_token: this.challengeToken
			}
		}).then((response) => {
			this.loadingText.destroy();
			this.challengeInfo = response.data;
			// Salva subito il game_mode_id in localStorage per essere disponibile quando parte il gioco
			if (this.challengeInfo.game_mode_id) {
				auth.saveGameModeId(this.challengeInfo.game_mode_id);
			}
			this.showChallengePreview();
		}).catch((error) => {
			console.error('Errore caricamento sfida:', error);
			this.loadingText.destroy();

			let errorMsg = 'Errore nel caricamento della sfida';
			if (error.response) {
				if (error.response.data && error.response.data.message) {
					errorMsg = error.response.data.message;
				} else if (error.response.status === 404) {
					errorMsg = 'Sfida non trovata o già accettata';
				}
			}

			this.showError(errorMsg);
		});
	}

	showChallengePreview() {
		var width = this.sys.game.config.width;
		var height = this.sys.game.config.height;
		var centerX = width / 2;
		var centerY = height / 2;

		// Mostra informazioni sfida
		var challengerName = this.challengeInfo.challenger.nickname;
		var challengerScore = this.challengeInfo.challenger.score;

		// Card con sfondo bianco arrotondato per le informazioni della sfida
		var cardWidth = width - 40;
		var cardHeight = 140;
		var cardX = 20;
		var cardY = centerY - 130;

		var cardGraphics = this.add.graphics();
		cardGraphics.fillStyle(0xFFFFFF, 0.95);
		cardGraphics.fillRoundedRect(cardX, cardY, cardWidth, cardHeight, 15);
		cardGraphics.lineStyle(2, 0xE0E0E0, 1);
		cardGraphics.strokeRoundedRect(cardX, cardY, cardWidth, cardHeight, 15);

		// Messaggio principale
		this.add.text(
			centerX,
			cardY + 45,
			challengerName + ' ti ha sfidato!',
			{
				fontSize: 28,
				fontFamily: 'Luckiest Guy',
				fill: '#1567a3'
			}
		).setOrigin(0.5);

		// Punteggio da battere
		this.add.text(
			centerX,
			cardY + 95,
			'Punteggio da battere: ' + challengerScore,
			{
				fontSize: 22,
				fontFamily: 'Luckiest Guy',
				fill: '#333333'
			}
		).setOrigin(0.5);

		// Verifica se utente è autenticato
		const isAuthenticated = auth.isAuthenticated();
		console.log('AcceptChallenge - isAuthenticated:', isAuthenticated, 'autoAccept:', this.autoAccept, 'token:', auth.getToken() ? 'presente' : 'assente');

		if (isAuthenticated) {
			// Utente autenticato
			if (this.autoAccept) {
				// Se autoAccept è true, accetta automaticamente la sfida (login automatico)
				console.log('Auto-accettazione sfida dopo login automatico');
				this.acceptChallenge();
			} else {
				// Altrimenti mostra bottone "Accetta sfida" (utente ha cliccato link sfida direttamente)
				const acceptButton = new Button(
					this,
					centerX,
					centerY + 50,
					'green-button',
					0.4,
					'Accetta sfida',
					false
				);

				acceptButton.on('pointerup', () => {
					this.acceptChallenge();
				});
			}
		} else {
			// Utente non autenticato: mostra form email
			this.showEmailForm();
		}

		// Bottone indietro
		var backButton = new Button(
			this,
			centerX,
			this.sys.game.config.height - 80,
			'red-button',
			0.8,
			'Indietro',
			false
		);

		backButton.on('pointerup', () => {
			this.scene.start('Login');
		});
	}

	showEmailForm() {
		var centerX = this.sys.game.config.width / 2;
		var centerY = this.sys.game.config.height / 2;

		// Messaggio
		this.add.text(
			centerX,
			centerY + 40,
			'Accedi per accettare la sfida',
			{
				fontSize: 20,
				fontFamily: 'Luckiest Guy',
				fill: '#FFFFFF'
			}
		).setOrigin(0.5);

		// Bottone login
		var loginButton = new Button(
			this,
			centerX,
			centerY + 100,
			'blue-button',
			0.4,
			'Accedi',
			false
		);

		loginButton.on('pointerup', () => {
			// Passa challenge_token come parametro alla scena Login
			this.scene.start('Login', { challenge_token: this.challengeToken });
		});
	}

	acceptChallenge() {
		// Verifica nuovamente autenticazione prima di procedere
		if (!auth.isAuthenticated()) {
			console.log('Utente non autenticato, reindirizzamento al login');
			this.scene.start('Login', { challenge_token: this.challengeToken });
			return;
		}

		// Assicurati che l'header Authorization sia impostato
		const token = auth.getToken();
		if (token) {
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
		} else {
			console.log('Token non trovato, reindirizzamento al login');
			this.scene.start('Login', { challenge_token: this.challengeToken });
			return;
		}

		const centerX = this.sys.game.config.width / 2;
		const centerY = this.sys.game.config.height / 2;

		// Mostra messaggio di caricamento
		if (this.loadingText) {
			this.loadingText.destroy();
		}
		this.loadingText = this.add.text(
			centerX,
			centerY,
			'Accettazione sfida...',
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FFFFFF'}
		).setOrigin(0.5);

		axios.post(`${config.apiUrl}/api/invites/accept-by-token`, null, {
			params: {
				challenge_token: this.challengeToken
			}
		}).then((response) => {
			this.loadingText.destroy();

			// Se l'API richiede autenticazione, reindirizza al login
			if (response.data.requires_auth === true) {
				console.log('Autenticazione richiesta, reindirizzamento al login');
				this.scene.start('Login', { challenge_token: this.challengeToken });
				return;
			}

			if (response.data.immediate_result) {
				// Risultato immediato: mostra scena ChallengeResult
				this.scene.start('ChallengeResult', {
					invite: response.data.invite,
					result: response.data.result
				});
			} else {
				// Nuovo round creato: avvia il gioco usando l'invite_id
				// Salva il game_mode_id della sfida per Boot (da response diretta, response.invite o da challengeInfo)
				var gameModeId = response.data.game_mode_id ||
					(response.data.invite && response.data.invite.game_mode_id) ||
					(this.challengeInfo && this.challengeInfo.game_mode_id);
				if (gameModeId) {
					auth.saveGameModeId(gameModeId);
				}
				// Avvia Boot che caricherà il round tramite invite_id
				this.scene.start('Boot', {
					invite_id: response.data.invite.id
				});
			}
		}).catch((error) => {
			console.error('Errore accettazione sfida:', error);
			this.loadingText.destroy();

			// Se l'errore è 400 o 401, probabilmente l'utente non è autenticato
			if (error.response && (error.response.status === 400 || error.response.status === 401)) {
				console.log('Errore autenticazione (400/401), reindirizzamento al login');
				this.scene.start('Login', { challenge_token: this.challengeToken });
				return;
			}

			let errorMsg = 'Errore nell\'accettazione della sfida';
			if (error.response) {
				if (error.response.data && error.response.data.message) {
					errorMsg = error.response.data.message;
				} else if (error.response.status === 401) {
					errorMsg = 'Non autenticato. Effettua il login.';
					// Salva token e porta a login
					localStorage.setItem('pending_challenge_token', this.challengeToken);
					this.time.delayedCall(2000, () => {
						this.scene.start('Login');
					});
				}
			}

			this.showError(errorMsg);
		});
	}

	showError(message) {
		if (this.errorText) {
			this.errorText.destroy();
		}
		this.errorText = this.add.text(
			this.sys.game.config.width / 2,
			this.sys.game.config.height / 2,
			message,
			{...setup.styles.gameOver.greetingStyle, fontSize: 24, fill: '#FF0000'}
		).setOrigin(0.5);

		// Bottone per tornare indietro
		const backButton = new Button(
			this,
			this.sys.game.config.width / 2,
			this.sys.game.config.height / 2 + 80,
			'red-button',
			0.8,
			'Indietro',
			false
		);

		backButton.on('pointerup', () => {
			this.scene.start('Login');
		});
	}
}
